





































































import Vue from 'vue'
import { range, groupBy } from 'lodash'
import moment, { Moment, MomentInput } from 'moment'
import store from '../../store'
import axios, { AxiosRequestConfig } from 'axios'

import { InterviewCalendar } from '@/queries/interviewCalendar.graphql'
import { InterviewCalendarQuery, InterviewCalendarQueryVariables } from '@/graphql-schema'

export type Interview = NonNullable<InterviewCalendarQuery['items']>['nodes'][0]

export default Vue.extend({
  apollo: {
    items: {
      query: InterviewCalendar,
      pollInterval: 10000,
      fetchPolicy: 'cache-and-network',
      variables(): InterviewCalendarQueryVariables {
        return {
          fromDatetime: this.fromDatetime,
          tilDatetime: this.tilDatetime,
        }
      },
    },
  },
  computed: {
    fromDatetime(): Moment {
      return moment(this.startOfMonth).startOf('week')
    },
    endOfMonth(): Moment {
      return moment(this.startOfMonth).endOf('month')
    },
    tilDatetime(): Moment {
      return moment(this.endOfMonth).endOf('week')
    },
    excelUrl(): String {
      return (
        '/auth/workreport?month=' +
        this.startOfMonth.format('M') +
        '&year=' +
        this.startOfMonth.format('Y')
      )
    },
    nextMonth(): Moment {
      return moment(this.startOfMonth)
        .add(1, 'month')
        .startOf('month')
    },
    previousMonth(): Moment {
      return moment(this.startOfMonth)
        .subtract(1, 'month')
        .startOf('month')
    },
    days(): Moment[] {
      const daysInRange = this.tilDatetime.diff(this.fromDatetime, 'days')
      return range(0, daysInRange + 1).map(days => moment(this.fromDatetime).add(days, 'days'))
    },
    formattedDates(): string[] {
      return this.days.map(m => this.key(m))
    },
    itemsByDate(): { [key: string]: Interview[] | undefined } {
      return groupBy(this.items!.nodes || [], item => this.key(item.startsAt))
    },
  },
  data(): { startOfMonth: Moment; items: InterviewCalendarQuery['items'] } {
    return {
      items: { nodes: [] },
      startOfMonth: moment().startOf('month'),
    }
  },
  methods: {
    key(date: MomentInput): string {
      return moment(date).format('YYYY-MM-DD')
    },
    interviewsAt(date: MomentInput): Interview[] {
      return this.itemsByDate[this.key(date)] || []
    },
    inCurrentMonth(date: MomentInput): boolean {
      return moment(date).isBetween(this.startOfMonth, this.endOfMonth, 'days', '[]')
    },
    isAvailable(offer: Interview): boolean {
      return (
        !offer.bookedAt &&
        offer.offerIsCanceled === false &&
        offer.isPast === false &&
        offer.bookingIsCanceled === false
      )
    },
    isBooked(offer: Interview): boolean {
      return (
        !!offer.bookedAt &&
        !offer.isSuicideCall &&
        offer.offerIsCanceled === false &&
        offer.bookingIsCanceled === false
      )
    },
    isCancelledOrPast(offer: Interview): boolean {
      return (
        ((offer.offerIsCanceled === true || offer.bookingIsCanceled === true) && !offer.isSuicideCall )
        || (offer.isPost === true && ( offer.hasTakenPlace == null || !offer.hasTakenPlace) && !offer.isSuicideCall )
      )
    },
    isPast(offer: Interview): boolean {
      return (
        offer.isPast === true &&
        offer.hasTakenPlace === false &&
        offer.offerIsCanceled === false &&
        offer.bookingIsCanceled === false
      )
    },
    isAccepted(offer: Interview): boolean {
      return offer.hasTakenPlace === true && offer.accepted === true && offer.isPost === false
    },
    isFeedback(offer: Interview): boolean {
      return offer.isPost === true && offer.hasTakenPlace === true
    },
    isRejected(offer: Interview): boolean {
      return (
        offer.hasTakenPlace === true &&
        (offer.accepted === false || offer.accepted == null) &&
        offer.counseling === false &&
        offer.isSuicideCall == false &&
        offer.bookingIsCanceled === false &&
        offer.offerIsCanceled === false
      )
    },
    isCounseling(offer: Interview): boolean {
      return (
        offer.hasTakenPlace === true &&
        (offer.accepted === false || offer.accepted == null) &&
        offer.counseling === true &&
        offer.isSuicideCall == false &&
        offer.bookingIsCanceled === false
      )
    },
    isSuicideCall(offer: Interview): boolean {
      return offer.isSuicideCall
    },
    async downloadWorkbook() {
      try {
        let token = store.getters.authToken
        const config: AxiosRequestConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }

        let axiosurl='/auth/workreport/?month=' +
          this.startOfMonth.format('M') +
          '&year=' +
          this.startOfMonth.format('Y')

        let response = await axios.get(axiosurl, config)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          'workreport_' +
            this.startOfMonth.format('MMMM') +
            '_' +
            this.startOfMonth.format('Y') +
            '.xlsx'
        ) // Setze den gewünschten Dateinamen
        document.body.appendChild(link)
        link.click();
        // Bereinige die URL
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Fehler beim Herunterladen der Excel-Datei', error)
      }
    },
    openCase(offer: Interview) {
      if (offer.caseId != null) {
        let url = this.$router.resolve({ name: 'admin.case', params: { caseId: offer.caseId } })
        window.open(url.href)
      }
    }
  },
})
